import React from 'react';
import spinner from '../../assets/sprites/spinner.svg';

interface ButtonProps {
  children?: React.ReactNode;
  isWhite?: boolean;
  status?: string;
  className?: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => null | void;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'default' | 'danger' | 'light';
}

const Button: React.FC<ButtonProps> = ({
  children,
  isWhite,
  status,
  type = 'button',
  variant = 'default',
  ...props
}) => {
  const baseClasses = 'w-full max-h-12 h-full px-5 py-3.5 rounded-lg font-semibold text-base leading-5 text-center cursor-pointer font-montserrat transition-all duration-300 flex justify-center items-center';

  const variantClasses = {
    default: 'bg-[#E3282A] text-white hover:bg-[#C91F21] active:bg-[#A81B1D] disabled:bg-[#CCCCCC] disabled:cursor-not-allowed',
    light: 'bg-white text-[#333] border border-[#333] hover:bg-[#e6e6e6] active:bg-[#ccc] focus:outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.3)] disabled:bg-[#ccc] disabled:text-[#888] disabled:border-[#888] disabled:cursor-not-allowed',
    danger: 'bg-white text-[#E3282A] border-2 border-[#E3282A] hover:bg-[#E3282A] hover:text-white focus:outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.3)] disabled:cursor-not-allowed'
  };

  const currentVariant = isWhite ? 'light' : variant;
  const buttonClasses = `${baseClasses} ${variantClasses[currentVariant]} ${props.className || ''}`;

  return (
    <button
      {...props}
      type={type}
      disabled={status === 'loading' || props.disabled}
      className={buttonClasses}
    >
      {status === 'loading' ? (
        <img
          className="w-6 h-6"
          style={{
            filter: 'brightness(0) saturate(100%) invert(95%) sepia(100%) saturate(0%) hue-rotate(105deg) brightness(103%) contrast(103%)'
          }}
          src={spinner}
          alt="Загрузка"
        />
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
